/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:9e877643-b166-45cc-b436-0921ef70e705",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_KR2nr2neE",
    "aws_user_pools_web_client_id": "5kla0e9bkud10euv0aa68b10e9",
    "oauth": {
        "domain": "sentido-engraver-prod.auth.eu-west-1.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://engravings.basalte.world/signin/",
        "redirectSignOut": "https://engravings.basalte.world/signout/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_appsync_graphqlEndpoint": "https://ua74tbsyi5fsdboddohsvjvyaa.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_user_files_s3_bucket": "sentido-engraver-storage-prod",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "aws_content_delivery_bucket": "sentido-engraver-20191105104722-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://d250u906bznrqg.cloudfront.net"
};


export default awsmobile;
